import './GroupTitle.742f5326c9611362257b1f43a05865a3.css';
export default {"groupTitle":"_groupTitle_12s8a_1","line":"_line_12s8a_1","title":"_title_12s8a_1","small":"_small_12s8a_1","light":"_light_12s8a_1"};